import { render } from "./BomValidationResultsElementsSendToSearchBtn.vue?vue&type=template&id=11d42797&scoped=true"
import script from "./BomValidationResultsElementsSendToSearchBtn.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsElementsSendToSearchBtn.vue?vue&type=script&lang=js"

import "./BomValidationResultsElementsSendToSearchBtn.vue?vue&type=style&index=0&id=11d42797&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d42797"]])

export default __exports__